export default __webpack_public_path__ + "static/media/sales.7d753153.svg";